/**
 * FlexFlow ERP - Application Configuration
 *
 * This is the main configuration file for the ERP frontend.
 * Change these settings to connect to different apps/databases.
 *
 * ============================================================
 */

// ===========================================
// ENVIRONMENT DETECTION
// ===========================================
const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost'
const isProduction = hostname === 'demo.flexflowerp.com'

// ===========================================
// API CONFIGURATION
// ===========================================

// Backend API URL — NEVER change this to a local IP or localhost.
// The frontend must ALWAYS point to the production backend.
export const API_URL = "https://be.devsoundfusion.com/api/v2/"

// ===========================================
// APP CONNECTION SETTINGS
// ===========================================

// App name - This determines which app/database to connect to
// Change this to switch between different apps (e.g., "flexflowdemo", "kerinodb", "medilog")
export const APP_NAME = "eliton"

// API Key for this app - Get this from Admin Panel > Apps > [Your App] > API Keys
export const APP_API_KEY = "dc776e1205ead6ac6e5d896c54cbf727ca85ed2f29775f071d244575f493cb00"

// ===========================================
// COMPUTED URLs (Don't modify these)
// ===========================================

// Base URL for app-specific endpoints
export const APP_URL = API_URL + APP_NAME + "/"

// ===========================================
// FEATURE FLAGS
// ===========================================

export const FEATURES = {
  // Enable/disable file storage functionality
  FILE_STORAGE: true,

  // Enable/disable VAT validation (Greek AADE)
  VAT_VALIDATION: true,

  // Enable/disable multi-company invoicing
  MULTI_COMPANY_INVOICING: true,

  // Enable/disable chat functionality
  CHAT: true,

  // Enable/disable workflow management
  WORKFLOW: true,
}

// ===========================================
// UI SETTINGS
// ===========================================

export const UI = {
  // Default language (en, gr, de)
  DEFAULT_LANGUAGE: "gr",

  // Items per page in tables
  PAGE_SIZE: 50,

  // Date format
  DATE_FORMAT: "DD/MM/YYYY",

  // Currency
  CURRENCY: "EUR",
  CURRENCY_SYMBOL: "€",
}

// ===========================================
// FILE STORAGE SETTINGS
// ===========================================

export const FILE_STORAGE = {
  // Maximum file size in bytes (50MB)
  MAX_FILE_SIZE: 50 * 1024 * 1024,

  // Allowed file extensions
  ALLOWED_EXTENSIONS: ["jpg", "jpeg", "png", "gif", "webp", "pdf", "doc", "docx", "xls", "xlsx"],

  // Default folder for uploads
  DEFAULT_FOLDER: "general",
}

// ===========================================
// EXPORT DEFAULT CONFIG
// ===========================================

export default {
  API_URL,
  APP_NAME,
  APP_API_KEY,
  APP_URL,
  FEATURES,
  UI,
  FILE_STORAGE,
  isProduction,
}
